import { useStore } from '../../store';
import { getMostRelevantCard } from '../../helpers/cardStatus.helper';

export interface IPeopleProperty {
  businessType: string;
  signup_date: Date | string;
  'Plan Type': string;
  'Main Source of Income': string
  'Has Emergency Bucket': boolean,
  'Emergency Bucket Auto Auto-Save Enabled': boolean,
  'Has Tax Bucket': boolean,
  'Tax Bucket Auto Auto-Save Enabled': boolean,
  Balance: number,
  accountStatus: string,
  hasCard: boolean,
  role: string,
  'BalanceUp Eligibility': boolean,
  'BalanceUp Enrolled': boolean,
  'Card activated': boolean,
  'Card frozen': boolean,
  customerId: string,
  personId: string
}

const {
  getSummaryData, getPersonalAccount, getPrimaryAccount, getPersonExternalId, currUser,
} = useStore.getState();

const mostRelevantCard = getMostRelevantCard(getPersonalAccount()?.cards || []);

export const generatePeoplePropertyProps = () => {
  const summaryData = getSummaryData();
  if (!summaryData || !summaryData?.customer) return null;

  const {
    customer: {
      businessType, tcTime, lastWebLoginTime, customerProfile, mainIncomeSource,
    }, emergencyBucketResponse, checkingTotalBalance, taxBucketBalance, accounts,
  } = summaryData;

  return {
    businessType,
    signup_date: tcTime,
    last_login: lastWebLoginTime,
    'Plan Type': customerProfile,
    'Main Source of Income': mainIncomeSource,
    'Has Emergency Bucket': !!emergencyBucketResponse,
    'Emergency Bucket Auto Auto-Save Enabled': emergencyBucketResponse.autoSave,
    'Has Tax Bucket': !!taxBucketBalance,
    'Tax Bucket Auto Auto-Save Enabled': taxBucketBalance.autoSave,
    Balance: checkingTotalBalance,
    accountStatus: accounts?.[0]?.accountStatus,
    hasCard: !!mostRelevantCard,
    role: accounts?.[0]?.role,
    'BalanceUp Eligibility': getPrimaryAccount()?.overdraft?.eligible,
    'BalanceUp Enrolled': getPrimaryAccount()?.overdraft?.optIn,
    'Card activated': !mostRelevantCard?.requireActivation,
    'Card frozen': mostRelevantCard?.locked,
    customerId: currUser()?.customerId,
    personId: getPersonExternalId(),
  } as IPeopleProperty;
};
